import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { useMediaQuery } from "@mui/material";
import LoginAunty from "../../assets/images/png/newDesign/girlFileTwo.png";
import i18n from "../../i18n";
import { useHistory } from "react-router-dom";
import "./fewMoreDetail.scss";
import Cookies from "js-cookie";
import tick from "../../assets/images/svg/newDesign/check-tick.svg";
import encryptStorage from "../../utils/encryptStorage";
import back from "../../assets/images/svg/newDesign/back.svg";
import backMobile from "../../assets/images/svg/newDesign/backMobile.svg";
import logo from "../../assets/images/svg/newDesign/logo.svg";
import call from "../../assets/images/svg/newDesign/call.svg";
import loadingGif from "../../assets/images/gif/loader_gif.gif";

const SignupFirstThankyou = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const [showCalendar, setShowCalendar] = useState(true);
  const [doctorstatus, setDoctorStatus] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  const uniqueCode = encryptStorage.getItem("unique_code");

  useEffect(() => {
    sessionStorage.setItem("alreadyShow", "alreadyshown");
    // setTimeout(() => {
    //   window.location.href = "/profile-setup";
    // }, 3000);
  }, []);

//   useEffect(() => {
//   const timer = setTimeout(() => {
//     setIsLoading(false);
//   }, 3000); 

//   return () => clearTimeout(timer);
// }, []);


    const navigateToLandingPage = () => {
      Cookies.remove("token");
      window.location.href = "/signup-number";
    };
  return (
   <>
  <StyledThankyou className="thankyouscreen">
       {/* <> */}
        {!isMobile && (
          <div className="header_meriSehat">
            <Container fluid>
              <Row>
                <Col md={12}>
                  <div className="logo_only">
                    <img src={logo} loading="lazy" className="logoEU" alt="Logo" />
                    <p className="phoneNumber">
                      <img src={call} loading="lazy" className="logoEU" alt="Phone" />
                      (021)-111-111-111
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        )}

        <Container style={{ paddingBottom: !isMobile ? "90px" : "50px" }}>
          <Row>
            <Col lg={12} className="backBtn">
              <h5 style={{ cursor: "pointer" }}>
                <img
                  src={!isMobile ? back : backMobile}
                  className="back"
                  onClick={navigateToLandingPage}
                />
                Back{" "}
              </h5>
            </Col>
          </Row>

          <div className="d-flex justify-content-center align-items-center">
            <div className="boxThankyou">
              <Row>
                {!isMobile && (
                  <Col md={5}>
                    <img className="img-fluid" src={LoginAunty} />
                    <div className="image-below d-sm-none d-block">
                      <div className="mt-70">
                        <button type="submit" className="btn-okay">
                          OKAY
                        </button>
                      </div>
                    </div>
                  </Col>
                )}

                <Col md={6} className="order-1 order-md-2">
                  <div
                    className={`content text-center py-5 mobile_style_thankyou ${
                      !isMobile ? "mt-4" : ""
                    }`}
                  >
                    <img
                      src={tick}
                      alt=""
                      style={{
                        width: isMobile ? "52px" : "",
                        height: isMobile ? "52px" : "",
                      }}
                    />
                    <h1 className="thankyou-heading mt-4">
                      {i18n.t("Thank You")}
                    </h1>

                    <p className="text-uppercase para-application my-4 d-none">
                      {i18n.t("Your Registration Number is")}
                    </p>

                    <div className="d-none">
                      <input
                        className="p-2 text-center application-number"
                        maxLength={6}
                        placeholder={uniqueCode}
                      />
                    </div>

                    <p className="mt-4 ContactText text-center">
                      {i18n.t(
                        "Your registration is almost complete, just a few more steps."
                      )}
                    </p>

                    <div className="mt-4">
                      <p className="saveText">
                        You will now be called for an orientation session while
                        we verify your PMDC number and will also be given a walk
                        through our platform and its features.
                      </p>
                      <p className="saveText mt-4">
                        Please select a time for your availability and one of
                        our customer happiness representatives will get in
                        touch with you.
                      </p>
                      <button
                        className="review-button mt-4 select-availabilty-btn position-relative text-uppercase"
                        onClick={() => {
                          history.push("/calendly-availability");
                        }}
                      >
                        Select Your availability
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      {/* </> */}
    {/* {isLoading ? (
      <div className="loaderWrapper">
        <img src={loadingGif} alt="" />
      </div>
    ) : (
   
    )} */}
  </StyledThankyou>
</>
  );
};

export const StyledThankyou = styled.section`
  .classPadding {
    padding: 0 9rem;
  }

  .bg-black {
    width: 60% !important ;
    margin: 1rem auto !important;
  }

  .para-application {
    font-family: "Satoshi-Light";
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 23px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #313131;
    justify-content: center;
  }

  .image-below {
    position: absolute;
    left: 0;
    bottom: 0;
  }

  .application-number {
    border-radius: 10px;
    border: none;
    width: fit-content;
    background: #cfeced;
    border-radius: 12.4651px;
    font-family: "Satoshi-Bold";
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 30px;
    /* display: flex; */
    /* align-items: center; */
    text-align: center;
    letter-spacing: 0.06em;
    color: #1fa7a8;
    max-width: 150px;

    input {
      font-family: "Satoshi-Medium";
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 30px;
      display: flex;
      align-items: center;
      text-align: center;
      letter-spacing: 0.06em;

      color: #313131;
    }
    input::placeholder {
      color: #1fa7a8;
    }
  }
`;

export default SignupFirstThankyou;


